import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import './styles/tokens.css';
import './styles/overrides.css';
import './styles/help.css';
import './styles/attachments.css';
import './i18n/i18n';
import { App } from './app/App';
import { installAuthListeners } from './app/auth';
import { applyLang, useUi } from './app/ui';
import { startTheme } from './app/theme';

installAuthListeners();
applyLang(useUi.getState().lang);
// before React renders, so a chosen theme is already on the page and the first paint does not flash the default
startTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
